<template>
	<div>
		<div>
			<!--新增录像机弹出框-->
			<div>
				<el-dialog title="新增录像机" :visible.sync="dialogFormVisible" :width="$store.state.width>$store.state.minwidth?'800px':($store.state.width-12+'px')" :before-close="formClose" center>
					<div v-loading="$store.state.formload">
						<el-form :model="newForm" :rules="rules" ref="newForm" :label-width="$store.state.width>$store.state.minwidth?'100px':''">
							<el-form-item label="录像机名称" prop="name" style="width:100%;">
								<el-input v-model="newForm.name" placeholder="请输入2~10个字符的名称"></el-input>
							</el-form-item>
							<!-- <el-form-item label="ip地址" prop="ip" style="width:100%;">
								<el-input v-model="newForm.ip" placeholder="例如：192.168.120.185:8080"></el-input>
						
							</el-form-item> -->
							<el-form-item label="用户名" prop="person" style="width:100%;">
								<el-input v-model="newForm.person" placeholder="请输入录像机的登录名"></el-input>
							</el-form-item>
							<el-form-item label="密码" prop="pass" style="width:100%;">
								<el-input v-model="newForm.pass" placeholder="请输入录像机的密码" autocomplete="new-password" show-password></el-input>
							</el-form-item>
						</el-form>
						<div slot="footer" class="dialog-footer">
							<el-button type="primary" @click="addAcount('newForm')">保 存</el-button>
							<el-button @click="dialogFormVisible = false">取 消</el-button>
						</div>
					</div>
				</el-dialog>
			</div>
				<!--编辑录像机弹出框-->
			<div>
				<el-dialog title="编辑录像机" :visible.sync="editFormVisible" :width="$store.state.width>$store.state.minwidth?'800px':($store.state.width-12+'px')" :before-close="formClose" center>
					<div v-loading="$store.state.formload">
						<el-form :model="editForm" :rules="rules" ref="editForm" :label-width="$store.state.width>$store.state.minwidth?'100px':''">
							<el-form-item label="录像机名称" prop="name" style="width:100%;">
								<el-input v-model="editForm.name" ></el-input>
							</el-form-item>
							<!-- <el-form-item label="ip地址" prop="ip" style="width:100%;">
								<el-input v-model="editForm.ip" ></el-input>
						
							</el-form-item>
							<el-form-item label="用户名" prop="person" style="width:100%;">
								<el-input v-model="editForm.person" ></el-input>
							</el-form-item>
							<el-form-item label="密码" prop="pass" style="width:100%;">
								<el-input v-model="editForm.pass" show-password></el-input>
							</el-form-item> -->
						</el-form>
						<div slot="footer" class="dialog-footer">
							<el-button type="primary" @click="editAcount()">修改</el-button>
							<el-button @click="editFormVisible = false">取 消</el-button>
						</div>
					</div>
				</el-dialog>
			</div>
			<div>
				<el-dialog title="新增子设备" :visible.sync="addFormVisible" :width="$store.state.width>$store.state.minwidth?'800px':($store.state.width-12+'px')" :before-close="formClose" center>
					<div v-loading="$store.state.formload">
						<el-form :model="addForm" :rules="rules" ref="addForm" :label-width="$store.state.width>$store.state.minwidth?'100px':''">
							<!-- <el-form-item label="ip地址" prop="ip" style="width:100%;">
								<el-input v-model="addForm.ip" placeholder="例如：192.168.120.185:8080"></el-input>
							</el-form-item> -->
							<el-form-item label="摄像头名" prop="name" style="width:100%;">
								<el-input v-model="addForm.name" placeholder="请输入摄像头名"></el-input>
							</el-form-item>
							<el-form-item label="用户名" prop="person" style="width:100%;">
								<el-input v-model="addForm.person" placeholder="请输入录像机的登录名"></el-input>
							</el-form-item>
							<el-form-item label="密码" prop="pass" style="width:100%;">
								<el-input v-model="addForm.pass" placeholder="请输入录像机的密码" autocomplete="new-password" show-password></el-input>
							</el-form-item>
						</el-form>
						<div slot="footer" class="dialog-footer">
							<el-button type="primary" @click="saveSubset()">保 存</el-button>
							<el-button @click="addFormVisible = false">取 消</el-button>
						</div>
					</div>
				</el-dialog>
			</div>
			<div>
				<el-dialog title="修改摄像头" :visible.sync="editSXVisible" :width="$store.state.width>$store.state.minwidth?'800px':($store.state.width-12+'px')" :before-close="formClose" center>
					<div v-loading="$store.state.formload">
						<el-form :model="editSX" :rules="rulesSX" ref="editSX" :label-width="$store.state.width>$store.state.minwidth?'100px':''">
							<!-- <el-form-item label="ip地址" prop="ip" style="width:100%;">
								<el-input v-model="addForm.ip" placeholder="例如：192.168.120.185:8080"></el-input>
							</el-form-item> -->
							<el-form-item label="摄像头名" prop="name" style="width:100%;">
								<el-input v-model="editSX.name" placeholder="请输入摄像头名"></el-input>
							</el-form-item>
						</el-form>
						<div slot="footer" class="dialog-footer">
							<el-button type="primary" @click="saveSX()">保 存</el-button>
							<el-button @click="editSXVisible = false">取 消</el-button>
						</div>
					</div>
				</el-dialog>
			</div>
		</div>
		<div>
			<el-row>
				<el-col :span="24">
					<div class="bread">
						<el-breadcrumb separator-class="el-icon-arrow-right">
							<el-breadcrumb-item v-if="$store.state.main.user.m_qaedas_id==0" :to="{ path: '/main' }">基地管理</el-breadcrumb-item>
							<el-breadcrumb-item>监控管理</el-breadcrumb-item>
						</el-breadcrumb>
					</div>
				</el-col>
			</el-row>
			<el-row class="top">
				<el-col :span="24">
					<el-button type="primary" icon="el-icon-circle-plus-outline" @click="openExpression()" :size="$store.state.width<$store.state.minwidth?'small':''">新增录像机</el-button>
					<el-tooltip content="数据有误,需点此刷新!" placement="top" effect="light">
						<el-button :disabled="$store.state.video.vcr.vcrList.length<=0" type="primary" icon="el-icon-refresh" @click="refresh()" :size="$store.state.width<$store.state.minwidth?'small':''">刷新</el-button>
					</el-tooltip>
				</el-col>
			</el-row>
			<el-row v-if="$store.state.video.vcr.vcrList.length>0||$store.state.video.vcr.vcrSonList.length>0">
				<el-col :span="24">
					<el-row>
						<el-col :span="24" v-for="site in $store.state.video.vcr.vcrList" :key="site.id">
							<el-col :span="24" class="top">
								<el-button type="primary" icon="el-icon-edit" circle @click="editExpression(site)" :size="$store.state.width<$store.state.minwidth?'small':''"></el-button>
								<span>&nbsp;&nbsp;{{site.name}}</span>
							</el-col>
							<el-col :span="24">
								<el-card shadow="hover" :body-style="{ padding: '0px' }" class="card1" v-for="value in site.videoList" :key="value.id">
									<el-row class="ljs-head">
										<div @click="Open(value)">
											<el-col :span="18" style="color: #F8F8FF; text-align: center; cursor: pointer;">{{value.name}}</el-col>
										</div>
										<el-col :span="6" style="color: #F8F8FF; text-align: center;">
											<el-button type="text" icon="el-icon-edit" @click="openSX(value)" style="padding: 3px 0; color: #F8F8FF;"></el-button>
										</el-col>
									</el-row>
									<div @click="Open(value)" style="cursor: pointer;">
										<el-row>
											<el-col :span="10" :xl="10" class="ljs-img" v-if="value.cdetector === '枪机'">
												<img class="border" src="./../../assets/video/qiangj.png" />
											</el-col>
											<el-col :span="10" :xl="10" class="ljs-img" v-else>
												<img class="border" src="./../../assets/video/qiuj.png" />
											</el-col>
											<el-col :span="9" class="dis-inbl">
												<p class="matter">通道号：</p>
												<p class="matter">类&nbsp;&nbsp;&nbsp;&nbsp;型：</p>
												<p class="matter">状&nbsp;&nbsp;&nbsp;&nbsp;态：</p>
											</el-col>
											<el-col :span="5" class="tex-ri">
												<p class="matter">{{value.channelsn}}</p>
												<p class="matter">{{value.cdetector}}</p>
												<p class="matter" :style="'color:' + (value.sbstatus==0?'red;':'green;')">{{value.switch==0?'已禁用':(value.sbstatus==0?'离线':'在线')}}</p>
											</el-col>
										</el-row>
									</div>
								</el-card>
							</el-col>
						</el-col>
					</el-row>
					<hr color=#45B2EB SIZE=1 style="margin-bottom: 20px;" class="top"/>
					<el-row>
						<el-col :span="24">
							<div class="left">
								<el-button type="primary" :size="$store.state.width<$store.state.minwidth?'small':''" icon="el-icon-circle-plus-outline" @click="openSubset()">添加子设备</el-button>
							</div>
						</el-col>
						<el-col :span="24" v-if="$store.state.video.vcr.vcrSonList.length>0">
							<div v-for="value in $store.state.video.vcr.vcrSonList" :key="value.id">
								<el-card shadow="hover" :body-style="{ padding: '0px' }" class="card1" v-if="value.videoList.length > 0">
									<el-row class="ljs-head">
										<div @click="Open(value.videoList[0])">
											<el-col :span="16" style="color: #F8F8FF; text-align: center; cursor: pointer;">{{value.videoList[0].name}}</el-col>
										</div>
										<el-col :span="8" style="color: #F8F8FF; text-align: center;">
											<el-button type="text" icon="el-icon-edit" @click="openSX(value.videoList[0])" style="padding: 3px 0; color: #F8F8FF;"></el-button>
											<el-button type="text" icon="el-icon-delete" @click="delSX(value.videoList[0])" style="padding: 3px 0; color: #F8F8FF;"></el-button>
										</el-col>
									</el-row>
									<div @click="Open(value.videoList[0])" style="cursor: pointer;">
										<el-row>
											<el-col :span="10" class="ljs-img" v-if="value.videoList[0].cdetector === '枪机'">
												<img class="border" src="./../../assets/video/qiangj.png" />
											</el-col>
											<el-col :span="10" class="ljs-img" v-else>
												<img class="border" src="./../../assets/video/qiuj.png" />
											</el-col>
											<el-col :span="9" class="dis-inbl">
												<p class="matter">通道号：</p>
												<p class="matter">类&nbsp;&nbsp;&nbsp;&nbsp;型：</p>
												<p class="matter">状&nbsp;&nbsp;&nbsp;&nbsp;态：</p>
											</el-col>
											<el-col :xs="4" :sm="5" :md="5" :lg="5" :xl="5" class="tex-ri">
												<p class="matter">{{value.videoList[0].channelsn}}</p>
												<p class="matter">{{value.videoList[0].cdetector}}</p>
												<p class="matter" :style="'color:' + (value.videoList[0].sbstatus==0?'red;':'green;')">{{value.videoList[0].switch==0?'已禁用':(value.videoList[0].sbstatus==0?'离线':'在线')}}</p>
											</el-col>
										</el-row>
									</div>
								</el-card>
							</div>
						</el-col>
						<el-col :span="24" v-else>
							<div class="none">
								<span>暂无数据 ！</span>
							</div>
						</el-col>
					</el-row>
				</el-col>
			</el-row>
			<el-row v-else>
				<el-col :span="24">
					<div class="none">
						<span>贵公司暂未购买视频监控服务 ！<br />如需购买请联系我公司市场部 。<br />联系电话：028-87972089</span>
					</div>
				</el-col>
			</el-row>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				myload: true,
				formload: false,
				dialogFormVisible: false,
				 	//新增界面数据
				newForm: {
					name: '',
					ip: '',
					person: '',
					pass: ''
				},
				 	//编辑界面数据
				editFormVisible: false,
				editForm: {
					id: '',
					name: '',
					ip: '',
					person: '',
					pass: ''
				},
				addFormVisible: false,
				addForm: {
					ip: '',
					name: '',
					person: '',
					pass: ''
				},
				rules: {
					name: [
						{ required: true, message: '请输入名称',	 trigger: 'blur' },
						{ min: 2, max: 8, message: '长度在 2 到 8 个字符', trigger: 'blur' }
					],
					ip: [
						{ required: true, message: '请输入IP',	 trigger: 'blur' }
					],
					person: [
						{ required: true, message: '请输入用户名',	 trigger: 'blur' }
					],
					pass: [
						{ required: true, message: '请输入密码',	 trigger: 'blur' }
					]
				},
				editSXVisible: false,
				editSX: {
					name: ''
				},
				rulesSX: {
					name: [
						{ required: true, message: '请输入摄像头名称',	 trigger: 'blur' },
						{ min: 2, max: 8, message: '长度在 2 到 8 个字符', trigger: 'blur' }
					]
				}
			}
		},
		methods: {
			openExpression()
			{
				this.dialogFormVisible = true;//新增界面数据
				this.$nextTick(()=>{
				    this.$refs['newForm'].resetFields();
				});
			},
			editExpression(site)
			{
				this.editFormVisible = true;//编辑界面数据
				this.$nextTick(()=>{
					this.$refs['editForm'].resetFields();
					this.editForm.id=site.id;
					this.editForm.name=site.name;
				});
			},
			addAcount(){
				this.$refs['newForm'].validate((valid) => {
					if(valid)
					{
						this.$store.commit('formload',true);
						let value={
							name: this.newForm.name,
							username: this.newForm.person,
							password: this.newForm.pass
						};
						this.addvcr(value)
						.then((response)=>{
							if(response.data.code==1)
							{
								this.dialogFormVisible = false;
							}
							this.$store.commit('formload',false);
						});
					}
				});
			},
			editAcount(){
				this.$refs['editForm'].validate((valid) => {
					if(valid)
					{
						this.$store.commit('formload',true);
						let value={
							id: this.editForm.id,
							name: this.editForm.name
						};
						this.editvcr(value)
						.then((response)=>{
							if(response.data.code==1)
							{
								this.editFormVisible = false;
							}
							this.$store.commit('formload',false);
						});
					}
				});
			},
			openSubset()
			{
				this.addFormVisible=true;
				this.$nextTick(()=>{
				    this.$refs['addForm'].resetFields();
				});
			},
			saveSubset(){
				this.$refs['addForm'].validate((valid) => {
					if(valid)
					{
						this.$store.commit('formload',true);
						let value={
							name: this.addForm.name,
							username: this.addForm.person,
							password: this.addForm.pass
						};
						this.addvideo(value)
						.then((response)=>{
							if(response.data.code==1)
							{
								this.addFormVisible = false;
							}
							this.$store.commit('formload',false);
						});
					}
				});
			},
			Open(item)
			{
				if(item.switch==0)
				{
					return;
				}
				if(item.sbstatus==0)
				{
					this.$confirm('该设备已离线，是否跳转？', '警告', {
						confirmButtonText: '跳转',
						cancelButtonText: '取消',
						type: 'warning'
					})
					.then(() => {
						this.$router.push({path:'singlectr',query:{ id: item.id}});
					})
				}
				else
				{
					this.$router.push({path:'singlectr',query:{ id: item.id}});
				}
			},
			saveSX()
			{
				this.$refs['editSX'].validate((valid) => {
					if(valid)
					{
						this.$store.commit('formload',true);
						let value={
							id: this.editSX.id,
							name: this.editSX.name
						};
						this.editvideo(value)
						.then((response)=>{
							if(response.data.code==1)
							{
								this.editSXVisible = false;
							}
							this.$store.commit('formload',false);
						});
					}
				});
			},
			openSX(item)
			{
				this.editSXVisible=true;
				this.$nextTick(()=>{
				    this.$refs['editSX'].resetFields();
					this.editSX.id=item.id;
					this.editSX.name=item.name;
				});
			},
			delSX(item)
			{
				this.$confirm('此操作将永久删除该摄像头，是否继续？', '警告', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
				})
				.then(() => {
					let value={
						id: item.id
					};
					this.delvideo(value);
				});
			},
			upstart(item)
			{
				this.$confirm('是否标记为'+item.switch==0?'可用':'禁用'+'？', '警告', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
				})
				.then(() => {
					let value={
						id: item.id
					};
					this.startpause(value);
				});
			},
			load()
			{
				
			},
			refresh()
			{
				this.refreshD();
			}
		},
		mounted: function () {
			this.load();
		}
	}
</script>
<style type="text/css" scoped>
	ul,li{ padding:0;margin:0;list-style:none}
	.left {
		position: relative;
		margin-right: 84%;
		margin-bottom: 10px;
	}
	.border{
		border-radius: 10rem; 
		box-shadow: darkgrey 0px 0px 8px 1px inset;
	}
	.right {
		position: relative;
		margin-left: 85%;
	}
	.bg-purple {
		background: white; 
		border-radius: 4px;
		min-height: 36px;
		height: 140px;
		margin-bottom: 20px;
		border: 1px solid #d3dce6;
		;
	}
	.ljs-head {
		background: #6f7e95;
		padding: 4px;
		border-radius: 4px 4px 0 0;
	}
	.ljs-img {
		height: 100px;
		text-align: center;
	}
	.ljs-img img {
		width: 100px;
		height: 100px;
		border-radius: 50%;
		margin-top: 5px;
	}
	.dis-inbl {
		line-height: 28px;
		text-align: right;
	}
	.tex-ri {
		line-height: 28px;
		text-align: left;
	}
	.matter {
		margin: 7px auto;
	}
	.el-form-item__content{
		display: inline-block !important;
		margin-left: 0 !important;
	}
	.top{
		margin-top: 10px;
	}
	.none{
		margin-top: 120px;
		margin-bottom: 80px;
		padding-left: 20%;
		/* text-align: center; */
		font-size: 60px;
		/* font-family: "STCaiyun"; */
		line-height: 90px;
		color: #1991FA;
	}
	.card1{
		width:233px;
		margin-top: 10px; 
		float: left;
		margin-right: 10px;
	}
	.bread{
		height: 14px;
		padding: 8px 0;
	}
	.dialog-footer {
		text-align: center;
	}
	@media screen and (min-width: 0px) and (max-width: 700px){
		.card1{
			width: 96%;
			margin: 5px auto;
			float: none;
		}
		.none{
			padding-left: 0;
			font-size: 40px;
			line-height: 50px;
			margin-top: 20px;
		}
	}
</style>